import { createSelector } from 'reselect';
import { GRADES } from '../hub/data/constants';

export const persistState = state => state.persistStateReducer;

export const getIsFieldTrial = createSelector([persistState], ({ isFieldTrial }) => isFieldTrial);
export const getIsStaffLogin = createSelector([persistState], ({ isStaffLogin }) => isStaffLogin);
export const getSchoolYearStart = createSelector([persistState], ({ schoolYearStart }) => schoolYearStart);

export const getAuthDataGrade = createSelector([persistState], ({ grade }) => grade);

export const getAuthDataGradeNoPreK = createSelector([persistState], ({ grade }) => {
  // treat pre-k students as kindergarten
  if (grade === GRADES.PRE_KINDERGARTEN) {
    return GRADES.KINDERGARTEN;
  }
  return grade;
});

export const getAuthDataRedirectToIPT = createSelector([persistState], ({ redirectToIpt }) => redirectToIpt);

// APT at BOY/MOY (mCLASS student w/o placement data): RWR + MTG (grade K is RWR only)
export const getAuthDataIsPlacementAPT = createSelector(
  [persistState],
  ({ isPlacementAPT, redirectToIpt }) => isPlacementAPT && redirectToIpt,
);

// ARBA at BOY/MOY (onboarding student): RWR + TRO
export const getAuthDataIsPlacementARBA = createSelector(
  [persistState],
  ({ isPlacementARBA, redirectToIpt }) => isPlacementARBA && redirectToIpt,
);

export const getAuthDataIsFirstLogin = createSelector([persistState], ({ isFirstLogin }) => isFirstLogin);

export const getAuthDataStudentId = createSelector([persistState], ({ studentId }) => studentId);

export const getAuthDataProductsAvailable = createSelector(
  [persistState],
  ({ productsAvailable }) => productsAvailable,
);
